import { getAnnouncementTranslation } from "./announcement.utils";

export { getAnnouncementTranslation };
